import * as t from 'io-ts';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';
import { createLocalStorageItem } from '../createLocalStorageItem';
import { LocalStorageItemState } from '../LocalStorageItemState';

const decodeIO = t.array(t.number);

const decode = buildValidator('localStorageRecentlyEvents.decodeIO', decodeIO, true);

export const localStorageRecentlyEvents = (withAutorun: boolean, key: string): LocalStorageItemState<Array<number>> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: []
    });
};

